import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import FormControlLabel from "@mui/material/FormControlLabel";
import HelperPopoverButton from "./HelperPopoverButton";
import React, { useEffect } from "react";

interface Props {
	settings: Record<string, string | boolean | string[]>;
	setSettingsPromise: (
		value: React.SetStateAction<Record<string, string | boolean | string[]>>,
	) => Promise<Record<string, string | boolean | string[]>>;
	label: string;
	slug: string;
	helper?: React.ReactNode | string;
	handleUpdateSettings: (
		settings: Record<string, string | boolean | string[]>,
	) => void;
}

const SettingsSwitchField = ({
	settings,
	setSettingsPromise,
	label,
	slug,
	helper,
	handleUpdateSettings,
}: Props) => {
	return (
		<>
			{settings[slug] === undefined || (settings[slug] as string).length < 0 ? (
				<Skeleton variant='rectangular' width='10%'>
					<Switch />
				</Skeleton>
			) : (
				<Box>
					<FormControlLabel
						control={
							<Switch
								type='checkbox'
								name='enable-test-mode'
								onChange={(e) => {
									setSettingsPromise({
										...settings,
										[slug]: e.target.checked.toString(),
									}).then((state) => handleUpdateSettings(state));
								}}
							/>
						}
						label={label}
						value={settings[slug] === "true"}
						checked={settings[slug] === "true"}
						sx={{ mr: 0.75 }}
					/>

					{Boolean(helper) && (
						<HelperPopoverButton>{helper}</HelperPopoverButton>
					)}
				</Box>
			)}
		</>
	);
};

export default SettingsSwitchField;
